import { styled } from "@mui/material";
import { Stepper, Step, StepLabel } from "@mui/material";
import React, { useState } from "react";
import "./StartupWizard.css";
import Organization from "src/components/Organization/OrganizationForm";
import User from "src/components/userForm";
import { useNavigate} from "react-router-dom";


const useStyles = styled((theme) => ({
  root: {
    backgroundColor: "#1C1E24",
    padding: 20,
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  return ["", ""];
}

function getStepContent(activeStep, handleNext, handleBack, steps, prevData) {
  switch (activeStep) {
    case 0:
      return <Organization props={{ handleNext, handleBack, activeStep, steps,custom:false,org:true }} />;
    case 1:
      return (
        <User
          props={{
            handleNext,
            handleBack,
            activeStep,
            steps,
            custom:false,
            update:true
          }}
        />
      );
   
    default:
      return "Unknown stepIndex";
  }
}

export default function Setup() {
  const navigate = useNavigate();
  const classes = useStyles();
  const [stepInfo, setStepInfo] = useState({ activeStep: 0, data: {} });
  const steps = getSteps();

  if (stepInfo.activeStep === steps.length) {
    navigate("..");
  }

  const handleNext = (data) => {
    setStepInfo((prevInfo) => {
      console.log('handle back, data:' + JSON.stringify(data))
      return { activeStep: prevInfo.activeStep + 1, data: data };
    });
  };

  const handleBack = () => {
    setStepInfo((prevInfo) => {
      console.log('handle back, data:' + JSON.stringify(prevInfo.data))
      return { activeStep: prevInfo.activeStep - 1, data: prevInfo.data };
    });
  };

  return (
    <div className="newComplexContainer">
      <div className="newcTiltle">
        <h2>Lets get started, tell us about your company</h2>
      </div>
      <div className="new">
        <div className={classes.root}>
          <Stepper activeStep={stepInfo.activeStep}>
            {steps.map((label, i) => (
              <Step key={label + i}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div>
            <div className="Contents">
              {
              getStepContent(
                stepInfo.activeStep,
                handleNext,
                handleBack,
                steps.length,
                stepInfo.data
              )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

